module.exports = __webpack_public_path__ + "img/download-phones-en.d5ec25e.png";